// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1VwUh","actions":"GroupTable_actions__10hvx","deleteModalFooter":"GroupTable_deleteModalFooter__23vP-"};